import * as React from "react";

function SvgRefreshCronDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path d="M24 0v24H0V0z" />
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M21.446 9.147l.084.073 1.5 1.5a.749.749 0 01-.976 1.133l-.084-.073-.231-.23A9.75 9.75 0 0112 21.75a9.729 9.729 0 01-7.985-4.165.748.748 0 01.184-1.044.748.748 0 011.044.184A8.232 8.232 0 0012 20.25a8.25 8.25 0 008.238-8.676l-.208.206a.75.75 0 01-.976.073l-.084-.073a.75.75 0 01-.073-.976l.073-.084 1.5-1.5a.75.75 0 01.976-.073zM14.537 7.5c.647 0 1.18.492 1.244 1.122l.006.128v.953c0 .333-.095.658-.272.937l-.095.136-.951 1.223.95 1.225c.17.219.285.474.337.744l.023.163.008.166v.953a1.25 1.25 0 01-1.122 1.244l-.128.006H9.463a1.25 1.25 0 01-1.244-1.122l-.006-.128v-.971c0-.316.086-.627.246-.895l.086-.13.907-1.255-.908-1.253a1.77 1.77 0 01-.297-.682l-.027-.185-.007-.157V8.75c0-.647.492-1.18 1.122-1.244l.128-.006h5.074zM12 2.25a9.729 9.729 0 017.985 4.165.748.748 0 01-.184 1.044.748.748 0 01-1.044-.184A8.232 8.232 0 0012 3.75a8.25 8.25 0 00-8.238 8.676l.208-.206a.75.75 0 01.976-.073l.084.073a.75.75 0 01.073.976l-.073.084-1.5 1.5a.75.75 0 01-.976.073l-.084-.073-1.5-1.5a.749.749 0 01.976-1.133l.084.073.231.23A9.75 9.75 0 0112 2.25z"
        />
        <path
          fill="#98DB69"
          d="M14.287 9H9.713v.722l.006.051.016.05.025.045 1.225 1.692c.167.23.188.53.063.777l-.062.103-1.227 1.695a.223.223 0 00-.04.092l-.006.052V15h4.574v-.703l-.006-.055-.018-.051-.029-.047-1.306-1.684a.752.752 0 01-.062-.826l.062-.094 1.307-1.684a.267.267 0 00.046-.098l.006-.055V9z"
        />
      </g>
    </svg>
  );
}

export default SvgRefreshCronDuo;
